// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* ESTILOS PARA CALENDARIO */\n.date-calendar[data-v-a538543a]{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center; \r\n    height: 15px;\n}\n.date-day[data-v-a538543a]{\r\n    font-weight: 400; \r\n    font-size: 10px;\n}\n.card-body[data-v-a538543a]{\r\n    position: relative;\n}\n.progress[data-v-a538543a]{\r\n    position: absolute;\r\n    width: calc( 100% + 40px);\r\n    top:0px;\r\n    left:0px;\n}\r\n\r\n\r\n", ""]);
// Exports
module.exports = exports;
